function getValuesByKey (items, column) {
    
    return items.map(function (item) {
        return item[column];
    });

}